interface Props {
  hasUnsavedChanges: boolean;
}

export default function ButtonSave({ hasUnsavedChanges }: Props) {
  return (
    <button
      type="submit"
      className={
        hasUnsavedChanges
          ? "universaleditmodal-right-button-unsaved"
          : "universaleditmodal-right-button-saved"
      }
    >
      Сохранить
    </button>
  );
}
